import dayjs from 'dayjs'
import { ReactElement } from 'react'
import { Box, Card, Skeleton, Typography } from '@mui/material'
import { UserGroup } from 'src/v3/manage/manage.slice'

type GroupDetailsCardProps = {
  group: UserGroup | null
  linkedServiceName: string
  isLoading: boolean
}

function GroupDetailsCardSkeleton(): ReactElement {
  return (
    <Card className="p-6 mb-6">
      <Typography variant="h6" component="h2" className="mb-4">
        Group Information
      </Typography>
      <Box className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Box>
          <Skeleton variant="text" width={80} height={20} className="mb-2" />
          <Skeleton variant="text" width="100%" height={32} />
        </Box>
        <Box>
          <Skeleton variant="text" width={120} height={20} className="mb-2" />
          <Skeleton variant="text" width="100%" height={32} />
        </Box>
        <Box>
          <Skeleton variant="text" width={100} height={20} className="mb-2" />
          <Skeleton variant="text" width="60%" height={32} />
        </Box>
        <Box>
          <Skeleton variant="text" width={100} height={20} className="mb-2" />
          <Skeleton variant="text" width="60%" height={32} />
        </Box>
      </Box>
    </Card>
  )
}

export default function GroupDetailsCard({
  group,
  linkedServiceName,
  isLoading,
}: GroupDetailsCardProps): ReactElement {
  if (isLoading || !group) {
    return <GroupDetailsCardSkeleton />
  }

  return (
    <Card className="p-6 mb-6">
      <Typography variant="h6" component="h2" className="mb-4">
        Group Information
      </Typography>
      <Box className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Box>
          <Typography variant="caption" color="text.secondary" className="mb-1">
            Name
          </Typography>
          <Typography variant="body1" className="font-semibold">
            {group.name}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" className="mb-1">
            Linked Service
          </Typography>
          <Typography variant="body1">{linkedServiceName}</Typography>
        </Box>
        {group.createdTime && (
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              className="mb-1"
            >
              Created
            </Typography>
            <Typography variant="body1">
              {dayjs(group.createdTime).format('MMM D, YYYY h:mm A')}
            </Typography>
          </Box>
        )}
        {group.updatedTime && (
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              className="mb-1"
            >
              Last Updated
            </Typography>
            <Typography variant="body1">
              {dayjs(group.updatedTime).format('MMM D, YYYY h:mm A')}
            </Typography>
          </Box>
        )}
      </Box>
    </Card>
  )
}
